import { getModel, getModelsForProvider } from './registry.js';
import type { ModelRole, ProviderId, RoleDefault } from './types.js';

const ROLE_DEFAULTS: Record<ModelRole, RoleDefault> = {
  npc_chat: { provider: 'gemini', modelId: 'gemini-3.1-flash-lite-preview' },
  agent: { provider: 'openrouter', modelId: 'anthropic/claude-sonnet-4-6' },
  reaction: { provider: 'gemini', modelId: 'gemini-3.1-flash-lite-preview' },
  summarization: { provider: 'gemini', modelId: 'gemini-3.1-flash-lite-preview' },
  content_generation: { provider: 'gemini', modelId: 'gemini-3-flash-preview' },
  embedding: { provider: 'gemini', modelId: 'gemini-embedding-001', dimensions: 768 },
  memory_compaction: { provider: 'gemini', modelId: 'gemini-3.1-flash-lite-preview' },
  simulation_action_resolution: { provider: 'gemini', modelId: 'gemini-3.1-flash-lite-preview' },
  simulation_cognitive_phase: { provider: 'gemini', modelId: 'gemini-3-flash-preview' },
  simulation_coordination: { provider: 'gemini', modelId: 'gemini-3-flash-preview' },
  simulation_formative_memory: { provider: 'gemini', modelId: 'gemini-3.1-flash-lite-preview' },
  simulation_workflow_comparison: { provider: 'gemini', modelId: 'gemini-3.1-flash-lite-preview' },
};

const REACTION_MODEL_BY_PROVIDER: Record<ProviderId, string> = {
  gemini: 'gemini-3.1-flash-lite-preview',
  openrouter: 'openai/gpt-4o-mini',
  anthropic: 'claude-3-5-haiku-latest',
};

const assertKnownRoleDefault = (role: ModelRole, value: RoleDefault): void => {
  if (!getModel(value.modelId, value.provider)) {
    throw new Error(`Unknown model registry default for role "${role}": ${value.modelId}`);
  }
};

for (const [role, value] of Object.entries(ROLE_DEFAULTS) as Array<[ModelRole, RoleDefault]>) {
  assertKnownRoleDefault(role, value);
}

for (const [provider, modelId] of Object.entries(REACTION_MODEL_BY_PROVIDER) as Array<
  [ProviderId, string]
>) {
  if (!getModel(modelId, provider)) {
    throw new Error(
      `Unknown model registry default for REACTION_MODEL_BY_PROVIDER["${provider}"]: ${modelId}`,
    );
  }
}

export const getDefaultForRole = (role: ModelRole): RoleDefault => ROLE_DEFAULTS[role];

export const getReactionModelForProvider = (provider: ProviderId): string =>
  REACTION_MODEL_BY_PROVIDER[provider] ??
  getModelsForProvider(provider).find((entry) => entry.capabilities.includes('chat'))?.id ??
  getDefaultForRole('reaction').modelId;

export { REACTION_MODEL_BY_PROVIDER, ROLE_DEFAULTS };
